import React from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { deleteFile } from "../../api/getMedia";

const MediaTable = ({ mediaData, fetchMedia }) => {
  const handleCopy = (url) => {
    navigator.clipboard
      .writeText(url)
      .then(() => toast.success("URL copied!"))
      .catch((error) => console.error("Failed to copy URL:", error));
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this media file?")) {
      try {
        const response = await deleteFile(id);
        if (response.success) {
          toast.success("Media deleted successfully!");
          await fetchMedia();
        } else {
          throw new Error(response.message);
        }
      } catch (error) {
        toast.error("Failed to delete media file.");
        console.error("Error deleting file:", error);
      }
    }
  };

  return (
    <div className="container py-4">
      <div className="table-responsive shadow-sm rounded bg-light p-3">
        <table className="table table-bordered table-striped align-middle">
          <thead className="table-primary">
            <tr>
              <th scope="col">S.No</th>
              <th scope="col">Preview</th>
              <th scope="col">File Name</th>
              <th scope="col">Type</th>
              <th scope="col">File Size</th>
              <th scope="col">Date Uploaded</th>
              <th scope="col">URL</th>
              <th scope="col" className="text-center">Actions</th>
            </tr>
          </thead>
          <tbody>
            {mediaData.map((item, index) => (
              <tr key={item.id}>
                <td>{index + 1}</td>
                <td>
                  {item.folder === "banner" ? (
                    <img
                      src={item.url}
                      alt={item.fileName || "Media file"}
                      className="img-thumbnail rounded"
                      style={{ maxWidth: "100px", maxHeight: "100px" }}
                      loading="lazy"
                    />
                  ) : (
                    <video
                      src={item.url}
                      controls
                      className="img-thumbnail rounded"
                      style={{ maxWidth: "100px", maxHeight: "100px" }}
                      preload="metadata"
                    >
                      Your browser does not support the video tag.
                    </video>
                  )}
                </td>
                <td style={{ maxWidth: "300px" }}> {item.fileName || "N/A"}</td>
                <td>{item.folder || "Unknown"}</td>
                <td>
                  {item.size
                    ? `${(item.size / (1024 * 1024)).toFixed(2)} MB`
                    : "N/A"}
                </td>
                <td>
                  {item.uploadedAt
                    ? new Date(item.uploadedAt).toLocaleString()
                    : "N/A"}
                </td>
                <td className="text-truncate" style={{ maxWidth: "200px" }}>
                  {item.url}
                </td>
                <td className="text-center">
                  <button
                    className="btn btn-outline-success btn-sm me-2"
                    onClick={() => handleCopy(item.url)}
                  >
                    Copy URL
                  </button>
                  <button
                    className="btn btn-outline-danger btn-sm"
                    onClick={() => handleDelete(item.id)}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
            {mediaData.length === 0 && (
              <tr>
                <td colSpan="8" className="text-center text-muted">
                  No media files available.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default MediaTable;
